@if (!disableHeader) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button (click)="closePopup()"></ion-menu-button>
      </ion-buttons>
      <ion-title style="font-size: 13px;">
        <div class="titleBar adjustedTitleFont">
          {{ 'Pluspage.Title'  | translate }}
          <!--
          @if (NotificationService.showNotificationBell) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">

                <app-app-icon [icon]="bellIcon" id="bellsize"></app-app-icon>
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
          -->
        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
}

<ion-content class="content-theme-one">

    @if ((mobile && !setting.navigationSetting) && setting.configuration.uIoptions) {
      <app-undocked-navigation-bar style="position: relative; z-index: 10;" [disabledOption]="title"></app-undocked-navigation-bar>
    }

    <div class="V10Format-layout">

      @if(this.setting.configuration.uIoptions?.showNutritionsTable || this.setting.configuration.uIoptions?.showAllergiesTable || this.setting.configuration.uIoptions?.showFlavorsTable) {
        <div class="general-Content">
          <h1 class="SectionTitle simpsonFont">
            {{ 'Pluspage.General'  | translate }}
          </h1>
          

          @if(this.setting.configuration.uIoptions?.showFlavorsTable) {
            <div class="linethrough"></div>

            <div class="Selection paytoneFont" (click)="changePage('FLAVOR')">
              {{ 'Pluspage.Flavors'  | translate }}
            </div>
          }
          

          @if(this.setting.configuration.uIoptions?.showNutritionsTable || this.setting.configuration.uIoptions?.showAllergiesTable) {
            <div class="linethrough"></div>

            <div class="Selection paytoneFont" (click)="changePage('NUTRI-ALLERGY')">
              {{ 'Pluspage.NutritionAllegie'  | translate }}
            </div>
          }

          <div class="linethrough"></div>
        </div>
      }
      


      <div class="my-Account-Content">
        <h1 class="SectionTitle simpsonFont">
          {{ 'Pluspage.MyAccount'  | translate }}
        </h1>
        <div class="linethrough"></div>

        <div class="Selection paytoneFont" (click)="changePage('SETTINGS')">
          {{ 'Pluspage.AccountSettings'  | translate }}
        </div>

        <div class="linethrough"></div>

        <div class="Selection paytoneFont" (click)="changePage('CARD')">
          {{ 'Pluspage.Cards'  | translate }}
        </div>

        <div class="linethrough"></div>

        <div class="Selection paytoneFont" (click)="changePage('TO-REWARDS-WALLET')">
          {{ 'Pluspage.Wallet'  | translate }}
        </div>

        <!--
        <div class="linethrough"></div>

        <div class="Selection paytoneFont" (click)="changePage('TO-ORDER')">
          {{ 'Pluspage.ToMenu'  | translate }}
        </div>
        -->

        <div class="linethrough"></div>

        <div class="Selection paytoneFont" (click)="changePage('ORDER-HISTORIC')">
          {{ 'Pluspage.OrderHistoric'  | translate }}
        </div>

        <div class="linethrough"></div>

        <!--@if(setting.configuration.navBarConfiguration.moveLoginLogoutToSettings) {-->
        @if(!(auth.isAuthenticated || setting.configuration.hideMemberProgram)) {
          <!--<div class="Selection paytoneFont" (click)="OpenLoginModal()">-->
          <div class="Selection paytoneFont" (click)="gotoLogin()">
            {{ 'Pluspage.Login'  | translate }}
          </div>

          <div class="linethrough"></div>
        } 
        
        @if (auth.isAuthenticated) {
          <div class="Selection paytoneFont" (click)="logout()">
            {{ 'Pluspage.Logout'  | translate }}
          </div>

          <div class="linethrough"></div>
        }
        

        <div class="policiesAndTerms">
          <div class="policiesAndTerms-container">
            <div class="policies poppinsNormalFont" (click)="showPolicies($event)">{{ 'Pluspage.PrivacyPolicy'  | translate }}</div>
            <div class="seperator"> {{' | '}} </div>
            <div class="terms poppinsNormalFont" (click)="showTerms($event)">{{ 'Pluspage.TaC'  | translate }}</div>
          </div>
          

          <div class="languageContainer">
            <!--
            @if (currentLanguages == 'en') {
              <div class="languageBox poppinsNormalFont" (click)="changeLang('fr')">
                {{ 'french' }}
              </div>
            }
            @if(currentLanguages == 'fr') {
              <div class="languageBox poppinsNormalFont" (click)="changeLang('en')">
                {{ 'english' }}
              </div>
            }
            -->
            <div class="languageBox poppinsNormalFont" (click)="changeLang('fr')">
              {{ 'Pluspage.French' | translate }}
            </div>
            <div class="seperator"> {{' | '}} </div>
            <div class="languageBox poppinsNormalFont" (click)="changeLang('en')">
              {{ 'Pluspage.English' | translate }}
            </div>
          </div>
        </div>

        <div class="externalLinks">
          @if(this.setting.configuration.link.facebook){
            <div class="link" (click)="useExternalLink('facebook')"><ion-icon style="cursor: pointer;" size="small" slot="start" [ios]="'logo-facebook'" [md]="'logo-facebook'"></ion-icon></div>
          }
          
          @if(this.setting.configuration.link.instagram){
            <div class="link" (click)="useExternalLink('instagram')"><ion-icon style="cursor: pointer;" size="small" slot="start" [ios]="'logo-instagram'" [md]="'logo-instagram'"></ion-icon></div>
          }

          @if(this.setting.configuration.link.twitter){
            <div class="link" (click)="useExternalLink('twitter')"><ion-icon style="cursor: pointer;" size="small" slot="start" [ios]="'logo-twitter'" [md]="'logo-twitter'"></ion-icon></div>
          }
          <!--
          <div class="link" (click)="useExternalLink('facebook')"><ion-icon style="cursor: pointer;" size="small" slot="start" [ios]="'logo-youtube'" [md]="'logo-youtube'"></ion-icon></div>
          -->
          @if(this.setting.configuration.link.tiktok){
            <div class="link" (click)="useExternalLink('ticktock')"><ion-icon style="cursor: pointer;" size="small" slot="start" [ios]="'logo-tiktok'" [md]="'logo-tiktok'"></ion-icon></div>
          }
          
        </div>
        
      </div>
      
    </div>
  

</ion-content>